import React, { useState, useEffect } from "react";
import "./PrivateEvents.css";
import HallRentalForm from "../components/HallRentalForm"
import { Helmet } from "react-helmet-async";

import island1 from "../assets/island1-min.webp";
import island2 from "../assets/island2-min.webp";
import island3 from "../assets/island3-min.webp";
import island4 from "../assets/island4-min.webp";
import island5 from "../assets/island5-min.webp";

import mainland1 from "../assets/mainland1-min.webp";
import mainland2 from "../assets/mainland2-min.webp";
import mainland3 from "../assets/mainland3-min.webp";
import mainland4 from "../assets/mainland4-min.webp";
import mainland5 from "../assets/mainland5-min.webp";

function PrivateEventsPage() {
  const islandImages = [island1, island2, island3, island4, island5];
  const mainlandImages = [
    mainland1,
    mainland2,
    mainland3,
    mainland4,
    mainland5,
  ];

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % islandImages.length);
        setFade(true);
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, [islandImages.length]);

  return (
    <div className="private-events-page page-container">
      <Helmet>
        <title>Private Events | LasGidi Restaurant</title>

        <meta
          name="description"
          content="Book LasGidi Restaurant's private event halls for birthdays, weddings, corporate dinners, and celebrations. Premium space, catering, and ambience."
        />

        <meta
          name="keywords"
          content="LasGidi Restaurant Event Hall, Manchester Party Venue, Nigerian Restaurant Events, Hall Booking Manchester, Private Event Space"
        />

        <meta
          property="og:title"
          content="Private Events | LasGidi Restaurant"
        />

        <meta
          property="og:description"
          content="Host your next event at LasGidi Restaurant. Perfect for birthdays, weddings, corporate parties, and private dining experiences."
        />

        <meta property="og:type" content="website" />
      </Helmet>
      
      <div className="events-container">
        <h1>Host Your Events</h1>
      </div>

      {/* Introductory Section */}
      <section className="intro-text">
        <p>
          Make your celebrations unforgettable with Lasgidi Restaurant. From
          corporate gatherings to intimate parties or a grand celebration, we
          have the ideal setting for you. Let us make your event unforgettable.
          <br />
          <br />
          Get in touch today, and let’s start planning together.
        </p>
      </section>

      {/* Our Halls Section */}
      <section className="event-halls">
        <h2 className="halls-heading">- Our Halls -</h2>
        <div className="halls-container">
          <div className={`hall island-hall ${fade ? "fade-in" : "fade-out"}`}>
            <img src={islandImages[index]} alt="Island Hall" />
            <div className="hall-overlay">
              <h2>Island Hall</h2>
            </div>
          </div>
          <div
            className={`hall mainland-hall ${fade ? "fade-in" : "fade-out"}`}
          >
            <img src={mainlandImages[index]} alt="Mainland Hall" />
            <div className="hall-overlay">
              <h2>Mainland Hall</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="rental-form-section">
        <HallRentalForm />
      </section>

      <a
        className="cta-button primary-btn inquire-button post-review-btn"
        href="tel:01615660344"
      >
        For enquiries, call 0161 566 0344
      </a>
    </div>
  );
}

export default PrivateEventsPage;
